var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"value"},[(_vm.hasValue)?_c('div',{style:([_vm.uppercase ? { 'text-transform': 'uppercase' } : ''])},[(_vm.currency)?_c('span',[_vm._v(_vm._s(_vm.valueToCurrency))]):_c('span',[_vm._v(_vm._s(_vm.value))])]):_c('span',[_vm._v("---")])])
}
var staticRenderFns = []

export { render, staticRenderFns }